import * as types from './mutation-types'
import * as actions from './actions'

const state = {
  growplanTaskError: '',
  growplanTaskLoading: 0,
  saveLifecycleTaskError: '',
  firstEvent: {},
  platformGroups: [],
  saveLifecycleTaskSuccess: {},
  saveLifecycleTaskLoading: false,
  lifecycleByStrain: [],
}

const getters = {
  growplanTaskError: state => state.growplanTaskError,
  growplanTaskLoading: state => state.growplantaskLoading,
  saveLifecycleTaskLoading: state => state.saveLifecycleTaskLoading,
  firstEvent: state => state.firstEvent,
  platformGroups: state => state.platformGroups,
  saveLifecycleTaskSuccess: state => state.saveLifecycleTaskSuccess,
  lifecycleByStrain: state => state.lifecycleByStrain,
}

const mutations = {
  [types.GET_GROWPLANS_INITIAL_REQUEST] (state) {
    state.growplantaskLoading += 1
    state.growplanTaskError = ''
    state.firstEvent = []
  },
  [types.GET_GROWPLANS_INITIAL_SUCCESS] (state, firstEvent) {
    state.growplantaskLoading -= 1
    state.growplanTaskError = ''
    state.firstEvent = firstEvent
  },
  [types.GET_GROWPLANS_INITIAL_FAILURE] (state, growplanTaskError) {
    state.growplantaskLoading -= 1
    state.growplanTaskError = growplanTaskError
    state.firstEvent = []
  },
  [types.GET_PLATFORM_GROUPS_REQUEST] (state) {
    state.growplantaskLoading += 1
    state.growplanTaskError = ''
    state.platformGroups = []
  },
  [types.GET_PLATFORM_GROUPS_SUCCESS] (state, platformGroups) {
    state.growplantaskLoading -= 1
    state.growplanTaskError = ''
    state.platformGroups = platformGroups
  },
  [types.GET_PLATFORM_GROUPS_FAILURE] (state, growplanTaskError) {
    state.growplantaskLoading -= 1
    state.growplanTaskError = growplanTaskError
    state.platformGroups = []
  },
  [types.SAVE_LIFECYCLE_TASK_REQUEST] (state) {
    state.saveLifecycleTaskLoading = true
    state.saveLifecycleTaskError = ''
    state.growplanTaskError = ''
    state.saveLifecycleTaskSuccess = {}
  },
  [types.SAVE_LIFECYCLE_TASK_SUCCESS] (state, saveLifecycleTaskSuccess) {
    state.saveLifecycleTaskLoading = false
    state.saveLifecycleTaskError = ''
    state.growplanTaskError = ''
    state.saveLifecycleTaskSuccess = saveLifecycleTaskSuccess
  },
  [types.SAVE_LIFECYCLE_TASK_FAILURE] (state, saveLifecycleTaskError) {
    state.saveLifecycleTaskLoading = false
    state.saveLifecycleTaskError = saveLifecycleTaskError
    state.saveLifecycleTaskSuccess = {}
    state.growplanTaskError = saveLifecycleTaskError
  },
  [types.GET_LIFECYCLE_STRAIN_REQUEST] (state) {
    state.growplantaskLoading = true
    state.growplanTaskError = ''
    state.lifecycleByStrain = []
  },
  [types.GET_LIFECYCLE_STRAIN_SUCCESS] (state, lifecycleByStrain) {
    state.growplantaskLoading = false
    state.growplanTaskError = ''
    state.lifecycleByStrain = lifecycleByStrain
  },
  [types.GET_LIFECYCLE_STRAIN_FAILURE] (state, growplanTaskError) {
    state.growplantaskLoading = false
    state.growplanTaskError = growplanTaskError
    state.lifecycleByStrain = []
  },

  [types.SET_PLATFORMS] (state) {
    state.platformGroups = []
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
